import { DEFAULT_CONTACT_EMAIL } from "../constants";

export const ACCELERATOR_CATEGORY_MAP = {
  servicenow: { label: "ServiceNow", className: "bg-emerald-100 text-emerald-800 border-emerald-200", railClass: "bg-emerald-600" },
  ragplatform: { label: "RAG Platform", className: "bg-indigo-100 text-indigo-800 border-indigo-200", railClass: "bg-indigo-600" },
  oracle: { label: "Oracle", className: "bg-sky-100 text-sky-800 border-sky-200", railClass: "bg-sky-600" },
  sap: { label: "SAP", className: "bg-teal-100 text-teal-800 border-teal-200", railClass: "bg-teal-600" },
  default: { label: "Accelerator", className: "bg-blue-100 text-blue-800 border-blue-200", railClass: "bg-brand-600" },
};

export const ACCELERATORS = [
  {
    id: "ragnative",
    title: "RagNative",
    category: "RAG Platform",
    accentKey: "default",
    tagline:
      "No-code, private RAG chatbot platform with full control and data sovereignty",
    logoUrl: "/assets/accelerators/ragnative.png",
    downloadUrl: "/downloads/RagNative.zip",
    contactEmail: DEFAULT_CONTACT_EMAIL,
    overview: [
      "RagNative enables enterprises to build, deploy, and operate AI chatbots securely within their own environment—without complexity or data risk.",
      "It is a packaged, no-code Retrieval-Augmented Generation (RAG) platform that allows organizations to use their own data, run on their own infrastructure, and bring their choice of LLMs (chat and embedding models).",
      "The platform handles the entire RAG lifecycle—knowledge ingestion, configurable chunking and vectorization, semantic search, and response generation—while giving full transparency and control over how answers are generated.",
      "It can be deployed on-premises or in private cloud environments, with zero dependency on external systems, and delivers chatbots instantly via shareable URLs or iFrame embeds.",
    ],
    benefits: [
      {
        title: "Absolute Data Sovereignty & Security",
        points: [
          "Zero Data Leakage: Data never leaves your environment; reduces risk associated with public/cloud-hosted AI.",
          "Built for Compliance: Ideal for regulated industries requiring strict data residency and privacy control.",
        ],
      },
      {
        title: "Lightning-Fast Time to Value",
        points: [
          "From Data to Chatbot in Minutes: No-code interface accelerates deployment vs. months of engineering.",
          "Instant Integration: Shareable URLs or iFrame embeds for quick rollout across portals and intranets.",
        ],
      },
      {
        title: "Total Control (No “Black Boxes”)",
        points: [
          "Bring Your Own Model: Swap LLMs/embeddings over time to stay best-in-class.",
          "Full Transparency: Control chunking, prompting, and context; answers can include source attribution.",
        ],
      },
      {
        title: "Eradicate Technical Complexity",
        points: [
          "No AI Experts Required: Platform manages backend orchestration so teams focus on business outcomes.",
        ],
      },
      {
        title: "High-Trust, Reliable Outputs",
        points: [
          "Goodbye Hallucinations: Ground responses in your documents and policies with tailored prompting.",
        ],
      },
    ],
  },
];
